export const TOAST_MESSAGES = {
    USERS_UPLOAD_SUCCESS: "Users uploaded successfully",
    USERS_UPLOAD_FAILED: "Failed to upload users",
    USERS_UPLOAD_ERROR: "Error uploading users",
    USERS_UPLOAD_PARTIAL:"Some users are not uploaded!",
    USERS_DELETE_SUCCESS: "Users deleted successfully",
    USERS_DELETE_PARTIAL: "Selected users are deleted successfully",
    USERS_DELETE_FAILED: "Failed to delete users!",
    USERS_DELETE_ERROR: "Error deleting users!",
    USERS_FETCH_FAILED: "Failed to fetch users!",
    USERS_FETCH_ERROR: "Error fetching users!",
    USERS_NOT_SELECTED: "No users selected!",
    USER_DELETE_SUCCESS: "User deleted successfully",
    USER_DELETE_FAILED: "Failed to delete user",
    USER_DELETE_ERROR: "Error deleting user",
    USER_UPDATION_SUCCESS: "User updated successfully",
    USER_UPDATION_FAILED: "User updation failed",
    USER_UPDATION_ERROR: "Error updating user",
    USER_NOT_SELECTED: "Please select a user",
    DUPLICATE_USER_SELECTED: "User already added to the project",
    ERROR_FETCHING_USERS: "Error fetching users",
    PROJECT_FETCH_FAILED: "Failed to fetch projects!",
    PROJECT_DETAILS_FAILED: "Failed To Fetch Project Details.",
    PROJECT_CREATED: "Project created successfully.",
    PROJECT_CREATION_ERROR: "Error creating project!",
    UPDATE_PROJECT_DETAILS_SUCCESS: "Project details updated!",
    UPDATE_PROJECT_DETAILS_FAILED: "Failed to update project details.",
    UPDATE_PROJECT_DETAILS_ERROR: "Error updating project details.",
    FETCHING_SITES_FAILED: "Failed to load sites.",
    FILES_FETCH_FAILED: "Failed to fetch files.",
    FILE_DELETE_FAILED: "Failed to delete file.",
    FILE_UPLOAD_FAILED: "Failed to upload file.",
    FILE_UPLOAD_SUCCESS: "File Uploaded Successfully.",
    FILE_DELETE_SUCCESS: "File deleted Successfully.",
    USER_ADD_SUCCESS: "User Added Successfully",
    USER_ADD_FAILED: "Failed to add user!",
    PROJECT_FILE_DELETE_ALERT: "Are you sure you want to delete this project file?",
    DOWNLOAD_EXCEL_FAILED: "Failed to download sample excel"
}

export const USER_ROLES = [
    { value: "MANAGING_DIRECTOR", label: "Managing Director" },
    { value: "HEAD_OFFICE", label: "Head Office" },
    { value: "GOVERNMENT_OFFICER", label: "Government Officer" },
    { value: "PROJECT_MANAGER", label: "Project Manager" },
    { value: "PROJECT_ENGINEER", label: "Project Engineer" },
    { value: "SITE_ENGINEER", label: "Site Engineer" },
]

export const PROJECT_FIELDS = [
    { key: "type", label: "Project Type", type: "select", options: [{value: "SOLAR", label: "Solar"}, { value: "EV", label: "EV" }, { value: "BOTH", label: "Both" }, { value: "OTHER", label: "Other" }]},
    { key: "category", label: "Category", type: "select", options: [{ value: "RESIDENTIAL", label: "Residential" }, { value: "COMMERCIAL", label: "Commercial" }, { value: "INDUSTRIAL", label: "Industrial" }, { value: "OTHER", label: "Other" },]},
    { key: "status", label: "Status", type: "select", options: [{ value: "PENDING", label: "Not Started" }, { value: "IN_PROGRESS", label: "In Progress" }, { value: "COMPLETED", label: "Completed" },]},
]

export const SITE_FIELDS = [
  { key: "site_name", label: "Site Name", type: "text" },
  { key: "state", label: "State", type: "text" },
  { key: "region", label: "Region", type: "text" },
  { key: "zone", label: "Zone", type: "text" },
  { key: "district", label: "District", type: "text" },
  { key: "location_url", label: "Location URL", type: "url" },
];

export const MESSAGES = {
    ALL_FILES_LOADED: "All files loaded",
    NO_FILES_AVAILABLE: "No files available!"
}
